module.exports = __webpack_public_path__ + "static/media/pressier.79f1edd8.jpg";